import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'activeInactive'
})
export class ActiveInactivePipe implements PipeTransform {
  transform(value: any, args?: any): string {

    if (typeof value === 'boolean') {
      return value ? 'ACTIVE' : 'INACTIVE';

    } else if (typeof value === 'string') {
      return value === 'Y' ? 'ACTIVE' : 'INACTIVE';
    } else {
      return null;
    }

  }

}
